<template>

    <div class="map-wrapper">

        <!-- :maxBounds="[
            10.8364783,
            55.2807139,
            24.1933675,
            69.059926
        ]" -->

        <MglMap
            :ref="'public-map'"
            :mapboxGl="mapboxgl"
            :mapStyle.sync="mapBoxSettings.mapStyle"
            :accessToken="mapBoxSettings.accessToken"
            @load="onMapLoaded"
            :center="currentMapCenter ? [ parseFloat(currentMapCenter.lng), parseFloat(currentMapCenter.lat)  ] : [ 14.6938511, 59.1232223 ]"
            :zoom="currentMapZoom"
            :minZoom="5"
            :maxZoom="18"
        >
            <MglNavigationControl position="bottom-right"/>

        </MglMap>

    </div>

</template>

<script>

import mapboxgl from 'mapbox-gl'

import { MglMap, MglNavigationControl } from 'vue-mapbox'

import mapBoxSettings from './../../mapbox-settings'

export default {

    components: {

        MglMap,

        MglNavigationControl

    },

    data() {

        return {

            mapbox : null,

            mapboxgl,

            mapBoxSettings,

            currentPlace: '',

            infoWindowPos: null,

            infoWinOpen: false,

            currentMidx: null,

            currentMapZoom : 6,

            currentMapCenter : null,

        };

    },

    methods: {

        onMapLoaded: function(event) {

            this.mapbox = event.component.mapbox

            this.map = event.map

            this.map.on('zoomend', () => this.zoom_changed() )

            this.addIconTypes()

            .then(()=> {

                const data = '/projects/geojson/'

                this.map.addSource('places', {
                    type: 'geojson',
                    tolerance: 0,
                    data: data
                })

                this.map.addLayer({
                    id : 'places',
                    type : 'symbol',
                    source : 'places',
                    layout : {
                        'icon-image': ['get', 'icon'],
                        'icon-allow-overlap': true,
                        "text-allow-overlap": true,
                    },

                    paint : {
                        'icon-opacity': 1
                    }
                })

                this.map.on('click', 'places', (e) => {

                    const coordinates = e.features[0].geometry.coordinates.slice()

                    if( coordinates ) {

                        const title = e.features[0].properties.title
    
                        const link = e.features[0].properties.link
    
                        new this.mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setHTML('<div><h6>'+ title +'</h6><a href="'+ link +'" target="_blank">Gå till dialog</a></div>')
                        .addTo(this.map)

                    }

                })

                this.map.on('mouseenter', 'places', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                })

                this.map.on('mouseleave', 'places', () => {
                    this.map.getCanvas().style.cursor = '';
                })

            })

        },

        addIconTypes: function() {

            return new Promise((resolve, reject) => {

                const types = ['pin_bra', 'pin_forbattra']

                types.forEach(imageName => {

                    this.map.loadImage(`/images/${imageName}.png`, (error, image) => {

                        if (error) throw error

                        this.map.addImage(imageName, image)

                    })

                })

                resolve()

            })

        },

        zoom_changed: function() {

            this.currentMapZoom = this.map.getZoom()

            this.currentMapCenter = this.map.getCenter()

        },

    }

};

</script>